import { ElementType, FC, ReactElement, SyntheticEvent } from 'react';
import { Flex, HStack, Link, LinkProps, Text } from '@chakra-ui/react';
import { CbNotificationBubble } from '../CbNotificationBubble';
export interface CbLeftMenuItemProps extends LinkProps {
  as: ElementType;
  href: string;
  isActive: boolean;
  isExternal?: boolean;
  label: string;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
  notificationCount?: number;
  onClick?: (event: SyntheticEvent) => void;
}
export const CbLeftMenuItem: FC<CbLeftMenuItemProps> = ({
  as,
  href,
  isActive,
  isExternal,
  label,
  leftIcon,
  rightIcon,
  notificationCount,
  onClick,
  ...rest
}) => {
  const opacity = !isActive ? 0.6 : 1;
  const navPadding = leftIcon != null ? 3 : 1;
  return <Link as={as} href={href} isExternal={isExternal} onClick={onClick} display="block" opacity={opacity} paddingY={navPadding} paddingX={3} borderRadius="md" transition="all 0.3s" lineHeight="base" aria-current={isActive ? 'page' : undefined} color="whiteAlpha.900" _hover={{
    background: '#0C2E6E',
    color: 'white'
  }} _activeLink={{
    background: '#0C2E6E',
    color: 'white'
  }} {...rest} data-sentry-element="Link" data-sentry-component="CbLeftMenuItem" data-sentry-source-file="CbLeftMenuItem.tsx">
      <HStack spacing={4} data-sentry-element="HStack" data-sentry-source-file="CbLeftMenuItem.tsx">
        {leftIcon}
        <Flex position="relative" data-sentry-element="Flex" data-sentry-source-file="CbLeftMenuItem.tsx">
          <Text fontWeight="semibold" marginTop={0.5} data-sentry-element="Text" data-sentry-source-file="CbLeftMenuItem.tsx">
            {label}
          </Text>
          <CbNotificationBubble marginLeft={1} count={notificationCount} backgroundImage="linear-gradient(150deg, #B182EA 10%, #FF3364 100%)" data-sentry-element="CbNotificationBubble" data-sentry-source-file="CbLeftMenuItem.tsx" />
        </Flex>
        {rightIcon}
      </HStack>
    </Link>;
};